import { SvgIcon } from 'ui/icons';
import { highchartColorPalette } from 'ui/theme';

export enum HIGHCHART_SYMBOL {
  CIRCLE = 'circle',
  DIAMOND = 'diamond',
  SQUARE = 'square',
  TRIANGLE = 'triangle',
  DOWN_TRIANGLE = 'triangle-down',
}

type SvgOptions = {
  height?: number;
  width?: number;
  color: string;
};

export const highchartSymbolsOrdered = [
  HIGHCHART_SYMBOL.CIRCLE,
  HIGHCHART_SYMBOL.DIAMOND,
  HIGHCHART_SYMBOL.SQUARE,
  HIGHCHART_SYMBOL.TRIANGLE,
  HIGHCHART_SYMBOL.DOWN_TRIANGLE,
];

export const getHighchartSymbolsSvg = (
  symbol: HIGHCHART_SYMBOL,
  { height = 12, width = 12, color }: SvgOptions,
) => {
  switch (symbol) {
    case HIGHCHART_SYMBOL.DIAMOND:
      return (
        <SvgIcon height={height} width={width} viewBox="0 0 12 12">
          <path
            d="M7.06064 1.64644C6.47485 1.06066 5.5251 1.06066 4.93932 1.64645L1.64644 4.93934C1.06066 5.52513 1.06066 6.47487 1.64644 7.06066L4.93932 10.3535C5.52511 10.9393 6.47485 10.9393 7.06064 10.3536L10.3535 7.06066C10.9393 6.47488 10.9393 5.52513 10.3535 4.93934L7.06064 1.64644Z"
            fill={color}
            stroke="white"
            strokeWidth="2"
          />
        </SvgIcon>
      );

    case HIGHCHART_SYMBOL.SQUARE:
      return (
        <SvgIcon height={height} width={width} viewBox="0 0 12 12">
          <rect
            x="1"
            y="1"
            width="8"
            height="8"
            rx="1.5"
            fill={color}
            stroke="white"
            strokeWidth="2"
          />
        </SvgIcon>
      );

    case HIGHCHART_SYMBOL.TRIANGLE:
      return (
        <SvgIcon height={height} width={width} viewBox="0 0 12 12">
          <path
            d="M7.30237 1.76357C6.72652 0.755852 5.27348 0.755852 4.69764 1.76357L1.55923 7.25579C0.987805 8.25578 1.70986 9.5 2.86159 9.5H9.13841C10.2901 9.5 11.0122 8.25578 10.4408 7.25579L7.30237 1.76357Z"
            fill={color}
            stroke="white"
            strokeWidth="2"
          />
        </SvgIcon>
      );

    case HIGHCHART_SYMBOL.DOWN_TRIANGLE:
      return (
        <SvgIcon height={height} width={width} viewBox="0 0 12 12">
          <path
            d="M7.30236 9.23643L6.43412 8.74029L7.30236 9.23643L10.4408 3.74421C11.0122 2.74422 10.2901 1.5 9.13841 1.5L2.86159 1.5C1.70986 1.5 0.987804 2.74422 1.55922 3.74421L4.69763 9.23643C5.27348 10.2441 6.72652 10.2441 7.30236 9.23643Z"
            fill={color}
            stroke="white"
            strokeWidth="2"
          />
        </SvgIcon>
      );

    case HIGHCHART_SYMBOL.CIRCLE:
    default:
      return (
        <SvgIcon height={height} width={width} viewBox="0 0 12 12">
          <path
            d="M3.76795 2.13397L4.26795 3L3.76795 2.13397C2.38675 2.93141 1.5359 4.40513 1.5359 6C1.5359 7.59487 2.38675 9.06859 3.76795 9.86603C5.14915 10.6635 6.85085 10.6635 8.23205 9.86603C9.61325 9.06859 10.4641 7.59487 10.4641 6C10.4641 4.40513 9.61325 2.93141 8.23205 2.13397C6.85085 1.33654 5.14915 1.33654 3.76795 2.13397Z"
            fill={color}
            stroke="white"
            strokeWidth="2"
          />
        </SvgIcon>
      );
  }
};

export const getChartSymbolAndColorByIndex = (index: number) => ({
  symbol: highchartSymbolsOrdered[index % highchartSymbolsOrdered.length],
  color: highchartColorPalette[index % highchartColorPalette.length],
});
